// Every analytics call of the app goes through here, so a blocked, slow or disabled vendor script can never break
// a page. Calls are forwarded to the vendors' globals (window.mixpanel, window._cio) when analytics are enabled
// and the global is there; a vendor error is logged, not thrown. With analytics disabled (development, tests) the
// calls are kept in a short list instead (window.__sensayAnalytics), so tests can check which events a flow sends.

const MAX_RECORDED = 200;
let enabled = true;
const recorded = [];

/** Turns forwarding on or off. Off: nothing reaches the vendors, calls are only recorded. */
export function configureAnalytics({ enabled: on }) {
  enabled = Boolean(on);
  if (!enabled && typeof window !== 'undefined') {
    window.__sensayAnalytics = recorded;
  }
}

export function analyticsEnabled() {
  return enabled;
}

function forward(vendor, path, args) {
  if (!enabled) {
    recorded.push({ vendor, call: path, args });
    if (recorded.length > MAX_RECORDED) recorded.shift();
    return;
  }
  try {
    const names = path.split('.');
    const method = names.pop();
    let target = typeof window !== 'undefined' ? window[vendor] : undefined;
    for (const name of names) target = target?.[name];
    if (typeof target?.[method] === 'function') target[method](...args);
  } catch (error) {
    console.warn(`analytics: ${vendor}.${path} failed`, error);
  }
}

/** Mixpanel, with the methods the app uses. */
export const mixpanel = {
  track: (...args) => forward('mixpanel', 'track', args),
  track_links: (...args) => forward('mixpanel', 'track_links', args),
  identify: (...args) => forward('mixpanel', 'identify', args),
  alias: (...args) => forward('mixpanel', 'alias', args),
  register: (...args) => forward('mixpanel', 'register', args),
  reset: (...args) => forward('mixpanel', 'reset', args),
  people: {
    set: (...args) => forward('mixpanel', 'people.set', args),
  },
};

/** Customer.io. */
export const customerIo = {
  identify: (...args) => forward('_cio', 'identify', args),
};
